import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("sb-security-settings")
export class SbSecuritySettings extends LitElement {
  @property({ type: Boolean }) loading = false;

  render() {
    if (this.loading) {
      return html`<div class="sb-account-settings-security-loading">
        Loading security settings...
      </div>`;
    }

    return html`
      <div class="sb-account-settings-security-panel">
        <rtg-empty>
          <rtg-empty-header>
            <rtg-empty-media variant="icon">
              <!-- You can replace this with a lock/shield icon later -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="sb-account-settings-security-icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 7a2 2 0 012 2m4 0a6 6 0 01-9.899 5.125M12 3v2m0 16v2m-9-9H3m2.129 5.243L4.343 19"
                />
              </svg>
            </rtg-empty-media>
            <rtg-empty-title>Security Settings</rtg-empty-title>
            <rtg-empty-description>
              Advanced security features are coming soon. Manage your passwords,
              2FA, active sessions, and more in future updates.
            </rtg-empty-description>
          </rtg-empty-header>

          <rtg-empty-content>
            <rtg-button variant="outline" size="sm">
              Check Security Status
            </rtg-button>
          </rtg-empty-content>

          <rtg-button variant="link" size="sm" href="#">
            Learn about security best practices
          </rtg-button>
        </rtg-empty>
      </div>
    `;
  }

  createRenderRoot() {
    return this;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "sb-security-settings": SbSecuritySettings;
  }
}
